import React from 'react';
import { WhereToBuy } from '../components/WhereToBuy';
import { Distributors } from '../components/Distributors';
import { PointsOfSale } from '../components/PointsOfSale';
import { Products } from '../components/Products';

export default function StorePage() {
  return (
    <>
      <Products />
      <WhereToBuy />
      <PointsOfSale />
      <Distributors />
    </>
  );
}
